module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.14c590d.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-brands-400.eot
// module id = 267
// module chunks = 1